import UnFavoritePreview from '@app/Likes/UnPreview'
import AddToFavorites from '@app/Likes/Add'

const FavoriteView = () => import('@app/Likes/View')

export default function install(Vue) {
  Vue.component(UnFavoritePreview.name, UnFavoritePreview)
  Vue.component('AddToFavorites', AddToFavorites)
  Vue.component('LikesView', FavoriteView)
}
